<template>
  <div>
    <div class="box">
      <div class="box-header with-border">
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">當日訂單數量與份數比較</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="today-amount-compare"></canvas>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">當日訂單數量與總額比較</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="today-money-compare"></canvas>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">當日訂單平均金額</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="today-money-average"></canvas>
            </div>
          </div>
        </div>
        <!--<div class="col-xs-12 col-md-6">-->
          <!--<h3 class="box-title">當日訂單數量</h3><br><br>-->
          <!--<div class="box-body p-0">-->
            <!--<div class="col-xs-12">-->
              <!--<canvas id="today-amount-average"></canvas>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">當日會員數量</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="shopper-brief"></canvas>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h3 class="box-title">今日24小時訂單數與金額</h3><br><br>
          <div class="box-body p-0">
            <div class="col-xs-12">
              <canvas id="hour-brief"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <order-line-charts />
    <div class="box">
      <div class="box-header with-border">
        <div class="col-xs-12">
          <h3 class="box-title">一日所有店家狀態列表<span class="text-red text-12">(最多可選擇10間店家)</span></h3><br><br>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  門市
                </span>
                <multiselect
                  v-model="content.bindingStoreList"
                  placeholder="選擇店家"
                  label="label"
                  track-by="value"
                  :options="storeBrief"
                  :multiple="true"
                  :allow-empty="true"
                  :close-on-select="false"
                />
              </div>
              <br />
            </div>
          </div>

        </div>
        <div class="col-xs-12 col-md-6 text-right pull-right">
          <div class="form-group input-group time-box pull-right no-btn">
            <date-time-picker :date="menuTime.storeTime" :option="dateoption" :limit="storeLimit"></date-time-picker>
            <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
            <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
            <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
            <!--
            <span class="input-group-btn">
              <button class="btn btn-default submit-btn btn-search" type="button"
                      id="search3" style="height: 36px" @click="clickSearch()">
                <i class="fa fa-search"></i>
              </button>
            </span>
            -->
          </div>
        </div>
        <div class="col-xs-12 table-responsive " style="min-height: 300px;">
          <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
            <thead>
            <tr role="row">
              <th>店名 (ID)</th>
              <th>已接受數量</th>
              <th>拒絕數量</th>
              <th>例外數量</th>
              <th>已完成數量</th>
              <th>一般單數量</th>
              <th>團購單數量</th>
            </tr>
            </thead>
            <tbody>
            <tr class="even" role="row" v-for="store in storeStatusList">
              <td>{{store.store_name}} ({{store.store_id}})</td>
              <td>{{store.order_count_accept}}</td>
              <td>{{store.order_count_reject}}</td>
              <td>{{store.order_count_accept - store.order_count_finish}}</td>
              <td>{{store.order_count_finish}}</td>
              <td>{{store.order_count_day_normal}}</td>
              <td>{{store.order_count_day_group}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import OrderLineCharts from '@/components/views/Chart/Temp/OrderLineCharts.vue'
var amountCompareChart, moneyCompareChart, moneyAverageChart, amountAverageChart, hourBriefChart, shopperBriefChart
import moment from 'moment'
export default {
  name: 'BrandDashboard',
  components: {
    'date-time-picker': datetimePicker,
    'order-line-charts': OrderLineCharts
  },
  data () {
    return {
      changeStore: false,
      storeStatusList: {},
      content: {
        bindingStoreList: []
      },
      oldUrl: '',
      storeBrief: [],
      brandBrief: [],
      // hour brief
      hourBriefLabels: [],
      hourBrief: {
        total_order: [],
        total_money: [],
        total_amount: []
      },
      // transactions
      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },
      // member brief
      memberBriefLabels: [],
      memberBrief: {
        total_day: [],
        total_accum: []
      },
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        },
        storeTime: {
          time: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      storeLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ]
    }
  },
  methods: {
    checkLimit (val) {
      if (this.content.bindingStoreList.length > 10) {
        this.content.bindingStoreList.shift()
      }
      if (this.content.bindingStoreList.length) {
        this.getStoresTransactions()
      } else {
        this.storeStatusList = {}
      }
    },
    clickSearch () {
      if (this.content.bindingStoreList.length) this.getStoresTransactions()
    },
    getStoresTransactions () {
      const list = this.content.bindingStoreList
      const day = moment(this.menuTime.storeTime.time, 'YYYY-MM-DD').format('YYYYMMDD')
      var ids = ''
      for (var i = 0; i < list.length; i++) {
        ids = ids + list[i].value + ','
      }
      ids = ids.slice(0, -1)
      var self = this
      var data = {
        start_time: day,
        end_time: day,
        ids: ids
      }
      var url = ''
      url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + data.ids
      if (this.oldUrl !== url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            let resDay = moment(day, 'YYYYMMDD').format('YYYY-MM-DD')
            if (response.data.statistics[resDay]) self.storeStatusList = response.data.statistics[resDay].store_info
            self.oldUrl = url
          }
        })
      }
    },
    getHourBrief (type, id) {
      this.hourBriefLabels = []
      this.hourBrief = {
        total_order: [],
        total_money: [],
        total_amount: []
      }
      var self = this
      var data = {
        result_type: 1
      }
      var url = '/statistic/storeHourBrief?result_type=' + data.result_type
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.brief
          for (let i in bList) {
            if (typeof parseInt(i, 10) === 'number' && parseInt(i, 10)) {
              if (bList[i].hour < 10) self.hourBriefLabels.push('0' + bList[i].hour + ':00')
              else self.hourBriefLabels.push(bList[i].hour + ':00')
              self.hourBrief.total_order.push(bList[i].total_order)
              self.hourBrief.total_money.push(bList[i].total_money)
              self.hourBrief.total_amount.push(bList[i].total_amount)
            }
          }
          self.getShoppers(type, id)
          self.showHourBriefChart()
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          self.getTransactions('brand', brandIds)
          if (bList.length === 1) self.getStoreBrief(brandIds)
        }
      })
    },
    getTransactions (type, id) {
      this.transactionLabels = []
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics
          var info
          for (var i in tList) {
            if (type === 'brand') {
              info = 'brand_info'
            } else if (type === 'store') {
              info = 'store_info'
            }
            self.transactionLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
            self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum)
            self.transactions.order_count_day.push(tList[i][info][id].order_count_day)
            self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal)
            self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group)
            self.transactions.money_accum.push(tList[i][info][id].money_accum)
            self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean)
            self.transactions.money_day.push(tList[i][info][id].money_day)
            self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal)
            self.transactions.money_day_group.push(tList[i][info][id].money_day_group)
            self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean)
            self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum)
            self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean)
            self.transactions.item_count_day.push(tList[i][info][id].item_count_day)
            self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal)
            self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group)
          }
          self.getHourBrief(type, id)
          self.showTransactionsChart(type)
        }
      })
    },
    getShoppers (type, id) {
      this.memberBriefLabels = []
      this.memberBrief = {
        total_day: [],
        total_accum: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandShopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.brand_shopper_status_list
          for (var i in bList) {
            self.memberBriefLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
            self.memberBrief.total_day.push(bList[i].total_day)
            self.memberBrief.total_accum.push(bList[i].total_accum)
          }
          self.showShopperChart(type)
        }
      })
    },
    showTransactionsChart (type) {
      this.$nextTick(() => {
        var datas = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交份數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_day,
          yAxisID: 'y-axis-1'
        }]
        var datas2 = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交金額',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day,
          yAxisID: 'y-axis-1'
        }]
        var datas3 = [{
          label: '當日平均金額',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day_mean
        }]
        /*
        var datas4 = [{
          label: '當日訂單數量',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-1'
        }]
        */
        if (typeof amountCompareChart !== 'undefined') {
          amountCompareChart.destroy()
        }
        if (typeof moneyCompareChart !== 'undefined') {
          moneyCompareChart.destroy()
        }
        if (typeof moneyAverageChart !== 'undefined') {
          moneyAverageChart.destroy()
        }
        if (typeof amountAverageChart !== 'undefined') {
          amountAverageChart.destroy()
        }
        var ctx = document.getElementById('today-amount-compare').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        var ctx2 = document.getElementById('today-money-compare').getContext('2d')
        var config2 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas2
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        var ctx3 = document.getElementById('today-money-average').getContext('2d')
        var config3 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas3
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        /*
        var ctx4 = document.getElementById('today-amount-average').getContext('2d')
        var config4 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas4
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        */
        amountCompareChart = new Chart(ctx, config) // eslint-disable-line no-new
        moneyCompareChart = new Chart(ctx2, config2) // eslint-disable-line no-new
        moneyAverageChart = new Chart(ctx3, config3) // eslint-disable-line no-new
        // amountAverageChart = new Chart(ctx4, config4) // eslint-disable-line no-new
      })
    },
    showHourBriefChart () {
      this.$nextTick(() => {
        var datas = [{
          label: '每小時訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.hourBrief.total_order,
          yAxisID: 'y-axis-2'
        }, {
          label: '每小時訂單金額',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.hourBrief.total_money,
          yAxisID: 'y-axis-1'
        }]
        if (typeof hourBriefChart !== 'undefined') {
          hourBriefChart.destroy()
        }
        var ctx = document.getElementById('hour-brief').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.hourBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        hourBriefChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    },
    showShopperChart (type) {
      this.$nextTick(() => {
        var datas = [{
          label: '當日會員數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.memberBrief.total_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日累積會員數量',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.memberBrief.total_accum,
          yAxisID: 'y-axis-1'
        }]
        if (typeof shopperBriefChart !== 'undefined') {
          shopperBriefChart.destroy()
        }
        var ctx = document.getElementById('shopper-brief').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.memberBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        shopperBriefChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    var date = new Date()
    this.menuTime.start.time = moment(date).add(-30, 'days').format('YYYY-MM-DD')
    this.fixedH()
    this.getBrandBrief()
  },
  watch: {
    'content.bindingStoreList' () {
      this.checkLimit()
    },
    'menuTime.storeTime.time' () {
      this.checkLimit()
    }
  }
}
</script>
<style lang="sass">
  .info-box
    cursor: pointer
  .info-box-content
    text-align: center
    vertical-align: middle
    display: inherit
  .fullCanvas
    width: 100%
  @media (min-width: 992px)
    .col-md-20-p
      width: 20%
      float: left
</style>



// WEBPACK FOOTER //
// BrandDashboard.vue?0a4420ef